
export const LC_AUTH_TOKEN = 'LC_AUTH_TOKEN';

export const CM_COUNTRY_ID = 35;